import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';


class AssetAdmin {

    assignSerialNumber(assetId, serialNumber, cabinetSerialNumber, suffix, isMultiModuleDrive = false, isApproved = false) {
        const endpoint = formatEndpoint(endpoints.assetAdmin.assignSerialNumber, { assetId });
        return RestManagerWithoutBaseUrl.put(endpoint, { assetId, serialNumber, cabinetSerialNumber, suffix, isMultiModuleDrive, isApproved });
    }

    validateSerialNumber(oldSerialNumber, newSerialNumber, suffix, isMultiModuleDrive) {
        const endpoint = formatEndpoint(endpoints.assetAdmin.validateSerialNumber, { oldSerialNumber });
        return RestManagerWithoutBaseUrl.post(endpoint, { newSerialNumber, oldSerialNumber, suffix, isMultiModuleDrive });
    }

    enableDisableDrive(assetId, isDisabled) {
        const endpoint = formatEndpoint(endpoints.assetAdmin.enableDisableDrive, { assetId });
        return RestManagerWithoutBaseUrl.put(endpoint, { assetId, isDisabled });
    }
}

export default new AssetAdmin();
